import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingsState {
	alarmEnabled: boolean;
	alarmThreshold: number;
	currentAlarmEnabled: boolean;
	currentAlarmThreshold: number;
	defaultAlarmSound: string;
}

const initialState: SettingsState = {
	alarmEnabled: localStorage.getItem("alarmEnabled") === "true" ? true : false,
	alarmThreshold: Number(localStorage.getItem("alarmThreshold")) || 100,
	currentAlarmEnabled: localStorage.getItem("alarmEnabled") === "true" ? true : false,
	currentAlarmThreshold: Number(localStorage.getItem("alarmThreshold")) || 0,
	defaultAlarmSound: localStorage.getItem("defaultAlarmSound") || "default",
};

export const themeSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		updateAlarmEnabled: (state, action: PayloadAction<boolean>) => {
			localStorage.setItem("alarmEnabled", action.payload.toString());
			state.alarmEnabled = action.payload;
		},
		updateAlarmThreshold: (state, action: PayloadAction<number>) => {
			localStorage.setItem("alarmThreshold", action.payload.toString());
			state.alarmThreshold = action.payload;
		},
		updateCurrentAlarmEnabled: (state, action: PayloadAction<boolean>) => {
			state.currentAlarmEnabled = action.payload;
		},
		updateCurrentAlarmThreshold: (state, action: PayloadAction<number>) => {
			state.currentAlarmThreshold = action.payload;
		},
		updateDefaultAlarmSound: (state, action: PayloadAction<string>) => {
			localStorage.setItem("defaultAlarmSound", action.payload);
			state.defaultAlarmSound = action.payload;
		},
	},
});

export const { updateAlarmEnabled, updateAlarmThreshold, updateCurrentAlarmEnabled, updateCurrentAlarmThreshold, updateDefaultAlarmSound } = themeSlice.actions;

export default themeSlice.reducer;
